export const MAX_TIME = 100;
export const MARBLE_SIZE = 2.3;
export const STROKE_WIDTH = 0.3;

export const containerWidth = { width: "1060px" };

export const userSelectNone = {
  userSelect: "none"
};

export const COLORS = {
  blue: "#3EA1CB",
  yellow: "#FFCB46",
  red: "#FF6946",
  green: "#82D736",
  white: "#FFFFFF",
  almostWhite: "#ECECEC",
  greyLight: "#D4D4D4",
  grey: "#A7A7A7",
  greyDark: "#7C7C7C",
  black: "#323232"
};
export const blue = { color: COLORS.blue };
export const yellow = { color: COLORS.yellow };
export const red = { color: COLORS.red };
export const green = { color: COLORS.green };
export const white = { color: COLORS.white };
export const almostWhite = { color: COLORS.almostWhite };
export const greyLight = { color: COLORS.greyLight };
export const grey = { color: COLORS.grey };
export const greyDark = { color: COLORS.greyDark };
export const black = { color: COLORS.black };
export const bgWhite = { backgroundColor: COLORS.white };

export const DIMENS = {
  spaceTiny: "5px",
  spaceSmall: "10px",
  spaceMedium: "22px",
  spaceLarge: "32px",
  spaceHuge: "42px",

  animationDurationQuick: "100ms",
  animationDurationNormal: "200ms",
  animationDurationSlow: "400ms"
};

export const FONTS = {
  base: "'Source Sans Pro', sans-serif",
  code: "'Source Code Pro', monospace",
  special: "'Signika', Helvetica, serif"
};
export const fontBase = { fontFamily: FONTS.base };
export const fontCode = { fontFamily: FONTS.code };
export const fontSpecial = { fontFamily: FONTS.special };

export const elevation1 = {
  "box-shadow": "0px 1px 2px 1px rgba(0,0,0,0.17)"
};

export const timelineStyle = {
  padding: `${DIMENS.spaceSmall} ${DIMENS.spaceMedium}`
};

export const POSSIBLE_COLORS = [
  COLORS.blue,
  COLORS.green,
  COLORS.yellow,
  COLORS.red
];

export const operatorsMenuItemStyle = Object.assign(
  {
    fontSize: "1rem",
    lineHeight: "1.6rem"
  },
  greyDark
);

export const operatorsMenuStyle = {
  marginRight: DIMENS.spaceLarge,
  boxSizing: "border-box",
  overflowY: "scroll",
  height: "calc(100vh - 150px)"
};

export const sandboxStyle = Object.assign(bgWhite, elevation1, {
  borderRadius: "2px"
});

export function getElevationPseudoElementStyle(
  dy: string,
  blur: string,
  opacity: string
) {
  return `
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    -webkit-box-shadow: 0 ${dy} ${blur} 0 rgba(0,0,0,${opacity});
    -moz-box-shadow: 0 ${dy} ${blur} 0 rgba(0,0,0,${opacity});
    box-shadow: 0 ${dy} ${blur} 0 rgba(0,0,0,${opacity});
  `;
}
